import React, { useEffect, useRef, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { Styles } from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import { useSnackbar } from "notistack";
import axios from "axios";
import { defaultVariables } from "../../../../config";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import MainPageSkeleton from "../../../components/loaders/MainPageSkeleton";
import SingleCardProduct from "../products/components/SingleCardProduct";
import Container from '@mui/material/Container';
import { useParams } from "react-router";
import {
    addressQueryString,
    calcTransferPrice, currencySymbol,
    estimateTransferTime,
    getMediaURL,
    getRandomIntInclusive, price,
    truncate
} from "../../../../config/values";
import Title from "../../../components/elements/Title";
import { Chip, Hidden, Typography, useMediaQuery } from "@mui/material";
import {
    Hourglass,
    PackageCheck,
    Star,
    Utensils,
    PiggyBank,
    Home,
    PackageOpen,
    Sparkles,
    BadgePercent, Bike, DollarSign, MapPinXInsideIcon, AlarmClockOff
} from "lucide-react";
import WishListButton from "./components/WishListButton";
import InfoButton from "./components/InfoButton";
import CommentsButton from "./components/CommentsButton";
import RayaField from "../../../components/elements/fields/RayaField";
import { theme } from "../../../../config/design/theme";
import CartWidget from "./components/CartWidget";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Swiper, SwiperSlide } from "swiper/react";
import Button from "@mui/material/Button";
import VendorSearchField from "../components/filters/VendorSearchField";
import {Link} from "react-router-dom";
import NothingFound from "../../../components/elements/NothingFound";
import {connect, setStore} from "trim-redux";
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import VendorPageSkeleton from "../../../components/loaders/VendorPageSkeleton";
import VendorOrderTime from "./components/VendorOrderTime";
import {Alert} from "@mui/lab";
import Lira from "../../../components/icons/Lira";
import Courier from "../../../components/icons/Courier";

function VendorPage({ classes,global_menu,user,isAuth }) {
    const { t } = useTranslation();
    let { slug } = useParams();
    const [data, setData] = useState(null);
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const random = getRandomIntInclusive(1, 999999999999);
    const [activeIndex, setActiveIndex] = useState(0);
    const [searchResult, setSearchResult] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedTime, setSelectedTime] = useState(null);
    const [addressId, setAddressId] = useState(null);
    const swiperRef = useRef(null);
    const sectionsRefs = useRef([]);
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const config = {
        headers: {
            Accept: 'application/json',
        }
    };
    const { enqueueSnackbar } = useSnackbar();

    const loadData = () => {
        setLoading(true);
        axios.get(`${defaultVariables.url}/front/vendor-page/${slug}${addressQueryString()}`, config)
            .then(response => {
                setData(response.data);
                setLoading(false);
                setCategories(!!response.data.categories ? response.data.categories : []);
                setStore(({
                    global_menu:response.data?.industry.name
                }))
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
            });
    };
    useEffect(() => {
        setStore({
            has_global_menu:false,
            selected_time:null,
        })
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        loadData();

        // Cleanup function to set has_global_menu to true when the component unmounts
        return () => {
            setStore({
                has_global_menu: true
            });
        };
    }, [slug]);
    useEffect(() => {
        if(isAuth){
            if(!!user.address){
                if(addressId !== user.address?.lat){
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                    loadData();
                    setAddressId(user.address?.lat)
                }
            }
        }
    }, [user]);

    useEffect(() => {
        const handleScroll = () => {
            const sections = sectionsRefs.current;
            let activeIndex = -1;

            sections.forEach((section, index) => {
                if(!!section){
                    const rect = section.getBoundingClientRect();
                    const sectionBottom = rect.top + rect.height;
                    // Check if the bottom of the section is still in the viewport and 200px is visible
                    if ((sectionBottom < 250 && sectionBottom > 0) || rect.top < 250 && rect.top > 0) {
                        activeIndex = index;
                    }

                    // If it's the last section, keep it active until it scrolls out of view
                    if (index === sections.length - 1 && sectionBottom <= window.innerHeight) {
                        activeIndex = index;
                    }
                }

            });

            if (activeIndex !== -1) {
                setActiveIndex(activeIndex);
            }
        };

        // Listen for scroll events
        window.addEventListener('scroll', handleScroll);

        // Cleanup the event listener
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [data]);


    useEffect(() => {
        if (swiperRef.current && typeof swiperRef.current.swiper.slideTo === 'function') {
            swiperRef.current.swiper.slideTo(activeIndex);
        }
    }, [activeIndex]);
    const handleScrollToMenu = (index) => {
        if (sectionsRefs.current[index]) {
            sectionsRefs.current[index].scrollIntoView({
                behavior: 'smooth',
            });
        }
    };
    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={!!loading ? t('vendorPage') : data?.name}>
            <div className={classes.vendorLayout}>
                {!!loading ? (
                        <VendorPageSkeleton />
                ) : (
                    <>

                        {/* Vendor Header Section */}
                        <section className={classes.vendorHeader}>
                            <Container maxWidth="xl">
                                {
                                    !!data.not_in_radius &&
                                    <Grid item size={12} className="mb-20">
                                        <Alert
                                            className="alert-no-icon"
                                            severity="error"
                                            icon={<MapPinXInsideIcon className="lucide-large"/>}
                                            action={
                                                <Button
                                                    component={Link}
                                                    variant="outlined"
                                                    to={`/${global_menu}/discover`}
                                                >
                                                    {t('available')} {t(global_menu)}
                                                </Button>
                                            }
                                        >
                                            <strong>{t('vendorNotInRadiusTitle')}</strong> {t('vendorNotInRadius')}
                                        </Alert>
                                    </Grid>
                                }
                                {
                                    (!data.timing?.is_open && !selectedTime) &&
                                    <Grid item size={12} className="mb-20">
                                        <Alert
                                            className="alert-no-icon"
                                            severity="error"
                                            icon={<AlarmClockOff className="lucide-large"/>}
                                            action={
                                                <Button
                                                    component={Link}
                                                    variant="outlined"
                                                    to={`/${global_menu}/discover`}
                                                >
                                                    {t('available')} {t(global_menu)}
                                                </Button>
                                            }
                                        >
                                            <strong>{t('vendorIsClosed')}</strong> {t('vendorIsClosedDesc')}
                                        </Alert>
                                    </Grid>
                                }
                                <Grid container spacing={2}>
                                    {
                                        !!isMobile &&
                                        <div className="vendor-breadcrumb">
                                            <BreadCrumbs
                                                front
                                                firstText={t(data?.industry?.name)}
                                                firstLink={`/${data?.industry?.name}`}
                                                secondText={data?.name}
                                            />
                                        </div>
                                    }

                                    <Grid item size={{ xs: 12, md: 9 }} className="header-sec">
                                        <div className="infos">
                                            <div className="mobileRate">
                                                <div className="logo">
                                                    <img src={getMediaURL(data.logo,'small')} alt={data.name} />
                                                </div>
                                                {
                                                    !!isMobile &&
                                                    <span className='rating-holder rating-vendor'><Star className="rating-icon" /> {data.average_rate}</span>
                                                }
                                            </div>

                                            <div className="informations">
                                                <div className="title-star-chip">
                                                    <Title component="h1" align="left" color="text" className="vendor-name">{data.name}</Title>
                                                    {
                                                        !isMobile &&
                                                    <span className='rating-holder rating-vendor'><Star className="rating-icon" /> {data.average_rate}</span>
                                                    }

                                                </div>
                                                {
                                                    !isMobile &&
                                                    <Typography className="description">{truncate(data.description, isMobile ? 50 : 90)}</Typography>
                                                }
                                                    <div className="details">
                                                        <div className='category'>
                                                            <Utensils className="lucide-small lucide-icon-white" />
                                                            <div className="category-holder">
                                                                {
                                                                    categories.map((category, index) => {
                                                                        if (index < 3) {
                                                                            return (
                                                                                <React.Fragment key={index}>
                                                                                    <Link to={`/${data.industry.name}/discover?categories=${category.id}`}>
                                                                                        {category.name}
                                                                                    </Link>
                                                                                    {index < 2 && <b className="dot"> • </b>}
                                                                                </React.Fragment>
                                                                            );
                                                                        } else if (index === 3) {
                                                                            return (
                                                                                <React.Fragment key={index}>
                                                                                    <span className="more-categories"> +{categories.length - 3}</span>
                                                                                </React.Fragment>
                                                                            );
                                                                        }
                                                                        return null;
                                                                    })
                                                                }
                                                            </div>
                                                        </div>

                                                        <span className='delivery details-text'><Hourglass className="lucide-small lucide-icon-white" /> {estimateTransferTime(data)} </span>
                                                        <span className={`min-order details-text ${(!!data.has_free_delivery && !data.free_delivery_limit) ? "free" : 'not-free'}`}><Courier fill="#fff" className="not-lucide white" /> {calcTransferPrice(data)}</span>
                                                        <span className={`min-order details-text`}><Lira  className="not-lucide white"/>{!!data.minimum_order ? price(data.minimum_order)+ currencySymbol : t('no')} {t('minimum')}</span>

                                                    </div>
                                                {
                                                    !isMobile &&
                                                    <div className="bellow-title">

                                                        <div className="chips-holder">
                                                            {
                                                                !!data.is_popular &&
                                                                <Chip
                                                                    icon={<Sparkles />}
                                                                    label={t('popular')}
                                                                    color="secondary"
                                                                    variant="contained"
                                                                    className="vendor-type-chip"
                                                                />
                                                            }
                                                            {
                                                                !!data.is_economic &&
                                                                <Chip
                                                                    icon={<BadgePercent />}
                                                                    label={t('economic')}
                                                                    color="secondary"
                                                                    variant="contained"
                                                                    className="vendor-type-chip"
                                                                />
                                                            }
                                                            {
                                                                !!data.is_pod &&
                                                                <Chip
                                                                    icon={<PackageCheck />}
                                                                    label={t('pod')}
                                                                    color="secondary"
                                                                    variant="contained"
                                                                    className="vendor-type-chip"
                                                                />
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                    {
                                                        !isMobile &&
                                                        <div className="mt-20">
                                                            <VendorOrderTime timing={data.timing} setTime={(time) => setSelectedTime(time)}/>
                                                        </div>
                                                    }


                                            </div>
                                        </div>
                                    </Grid>
                                    {
                                        !!isMobile &&
                                        <div className="bellow-title">
                                            <div className="chips-holder">
                                                {
                                                    !!data.is_popular &&
                                                    <Chip
                                                        icon={<Sparkles />}
                                                        label={t('popular')}
                                                        color="secondary"
                                                        variant="contained"
                                                        className="vendor-type-chip"
                                                    />
                                                }
                                                {
                                                    !!data.is_economic &&
                                                    <Chip
                                                        icon={<BadgePercent />}
                                                        label={t('economic')}
                                                        color="secondary"
                                                        variant="contained"
                                                        className="vendor-type-chip"
                                                    />
                                                }
                                                {
                                                    !!data.is_pod &&
                                                    <Chip
                                                        icon={<PackageCheck />}
                                                        label={t('pod')}
                                                        color="secondary"
                                                        variant="contained"
                                                        className="vendor-type-chip"
                                                    />
                                                }
                                            </div>
                                        </div>
                                    }
                                    <Grid item size={{ xs: 12, md: 3 }} className="mobile-actions-holder">
                                        <div className="actions">
                                            <WishListButton id={data.id} />
                                            <div className="info-buttons-vendor">
                                                <InfoButton data={data} />
                                                <CommentsButton data={data}/>
                                            </div>
                                        </div>
                                        <Hidden mdUp>
                                            <VendorOrderTime timing={data.timing} setTime={(time) => setSelectedTime(time)}/>
                                        </Hidden>
                                    </Grid>

                                </Grid>
                            </Container>
                        </section>

                        {/* Vendor Menu Section */}
                        <Container maxWidth="xl" className={classes.vendorMenuContainer}>
                            <Grid container spacing={2}>
                                <Grid item size={12}>
                                    <div className={classes.vendorMenuHolder}>
                                        <Grid container spacing={2} className="container">
                                            <Grid item size={{ xs: 10, md: 9 }}>
                                                <div style={{position:"relative",padding:!isMobile ?"0 50px" : 0}}>
                                                    {
                                                        !isMobile &&
                                                        <>
                                                            <button className={`raya-swiper-arrow raya-swiper-prev menu-swiper raya-swiper-prev-${random}`}>
                                                                <ChevronLeft size={24} />
                                                            </button>
                                                            <button className={`raya-swiper-arrow raya-swiper-next menu-swiper raya-swiper-next-${random}`}>
                                                                <ChevronRight size={24} />
                                                            </button>
                                                        </>
                                                    }

                                                    <Swiper
                                                        ref={swiperRef}
                                                        modules={[Navigation, Pagination, Autoplay]}
                                                        spaceBetween={10}
                                                        slidesPerView="auto"
                                                        navigation={
                                                            !isMobile
                                                                ? { prevEl: `.raya-swiper-prev-${random}`, nextEl: `.raya-swiper-next-${random}` }
                                                                : false
                                                        }
                                                        breakpoints={{
                                                            576: { spaceBetween: 10 },
                                                            768: { spaceBetween: 10 },
                                                            992: { spaceBetween: 20 },
                                                            1280: { spaceBetween: 20},
                                                        }}
                                                        /*onSlideChange={(swiper) => {
                                                            const adjustedIndex = swiper.activeIndex;
                                                            setActiveIndex(adjustedIndex);
                                                            if (sectionsRefs.current[adjustedIndex]) {
                                                                sectionsRefs.current[adjustedIndex].scrollIntoView({
                                                                    behavior: 'smooth',
                                                                });
                                                            }
                                                        }}*/
                                                    >
                                                        {data.menus?.map((menu, index) => (
                                                            <SwiperSlide
                                                                key={index}
                                                                className={activeIndex === index ? 'active-slide' : ''}
                                                            >
                                                                <Button color='text' className="menu-name" onClick={() => handleScrollToMenu(index)}>
                                                                    {menu.name} ({menu.products_count})
                                                                </Button>
                                                            </SwiperSlide>
                                                        ))}
                                                    </Swiper>
                                                </div>
                                            </Grid>
                                            <Grid item size={{ xs: 2, md: 3 }}>
                                                <VendorSearchField vendor_id={data.id} setSearchQuery={(q) => setSearchQuery(q)} searchResult={(res) => setSearchResult(res)}/>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </Container>

                        {/* Vendor Products Section */}
                        <Container maxWidth="xl">
                            <Grid container spacing={2} justify="center">
                                <Grid item size={{ xs: 12, lg: 9 }}>
                                    <Grid container spacing={2} justify="center" className="mt-20">
                                        {
                                            (!!searchResult.length || !!searchQuery) &&
                                            <Grid className="menu-holder-grid" item size={12} >
                                                <Title color="text" component="h2" align="left" className="menu-title">{t('searchResultFor')} "{searchQuery}"</Title>
                                                <Grid container spacing={2} className="search-results-vendor">
                                                    <>
                                                        {
                                                            !!searchResult.length ?
                                                                <>
                                                                    {searchResult.map((product, index) => (
                                                                        <Grid item size={{ xs: 12 ,md:6}} key={index}>
                                                                            <SingleCardProduct
                                                                                product={product}
                                                                                addtocart
                                                                                disabled={!!data.not_in_radius || (!data.timing?.is_open && !selectedTime)}
                                                                            />
                                                                        </Grid>
                                                                    ))}
                                                                </>
                                                                :
                                                                <Grid item size={{ xs: 12 }} >
                                                                    <Typography>{t('noResultsFound')}</Typography>
                                                                </Grid>
                                                        }

                                                    </>

                                                </Grid>
                                            </Grid>
                                        }
                                        <>
                                            {
                                                !!data.menus.length ?
                                                    <>
                                                        {data.menus.map((menu, i) => (
                                                            <Grid className="menu-holder-grid" item size={12} key={menu.id} id={`menu_${menu.id}`} ref={(el) => (sectionsRefs.current[i] = el)}>
                                                                <Title color="text" component="h2" align="left" className="menu-title">{menu.name}</Title>
                                                                <Grid container spacing={2}>
                                                                    {menu.products.map((product, index) => (
                                                                        <Grid item size={{ xs: 12 ,md:6}} key={index}>
                                                                            <SingleCardProduct
                                                                                product={product}
                                                                                addtocart
                                                                                disabled={!!data.not_in_radius || (!data.timing?.is_open && !selectedTime)}
                                                                            />
                                                                        </Grid>
                                                                    ))}
                                                                </Grid>
                                                            </Grid>
                                                        ))}
                                                    </>
                                                    :
                                                    <Grid item size={12}>
                                                        <NothingFound
                                                            type="page"
                                                            title={t('noProductFound')}
                                                            title_color="text"
                                                            paragraph={t('noProductFoundTryOtherVendors')}
                                                            icon={<PackageOpen/>}
                                                        >
                                                            <Button
                                                                variant="outlined"
                                                                endIcon={<ChevronRight/>}
                                                                component={Link}
                                                                to={`/${data.industry.name}`}
                                                            >
                                                                {t('viewOtherVendors')}
                                                            </Button>
                                                        </NothingFound>
                                                    </Grid>
                                            }
                                        </>

                                    </Grid>
                                </Grid>
                                <Hidden mdDown>
                                    <Grid item size={{ xs: 12, lg: 3 }}>
                                        <CartWidget vendor_id={data.id}/>
                                    </Grid>
                                </Hidden>
                            </Grid>
                        </Container>
                    </>
                )}
            </div>
        </AppAnimate>
    );
}
const mstp = state => ({
    user: state.user,
    isAuth: state.isAuth,
    has_global_menu: state.has_global_menu,
    global_menu: state.global_menu,
});
export default withStyles(Styles)(connect(mstp)(VendorPage));